<template>
  <swiper
    class="slider-swiper-full-width"
    :class="{
      '--no-padding-bottom': props.slides.length <= 1,
    }"
    :modules="[Pagination, A11y, Navigation]"
    :slides-per-view="1"
    :pagination="{ clickable: false }"
    :navigation="{
      nextEl: nextButton,
      prevEl: prevButton,
    }"
    :lazy="true"
  >
    <swiper-slide v-for="(slide, index) in props.slides" :key="index">
      <div
        class="slider-swiper-full-width__slide__wrap ratio-full-screen --force-landscape"
      >
        <WidgetPicture
          :image="{
            custom: slide.landscape,
          }"
          :lazyLoad="true"
          :alt="slide.title"
        />
      </div>
    </swiper-slide>
    <!-- Navigation-->
    <div class="swiper-buttons m-top-6" v-if="props.slides?.length > 1">
      <button
        class="swiper-button-prev"
        ref="prevButton"
        aria-label="Button Prev"
      ></button>
      <button
        class="swiper-button-next"
        ref="nextButton"
        aria-label="Button Next"
      ></button>
    </div>
  </swiper>
</template>

<script>
export default {
  name: 'WidgetSliderSwiperFullWidth',
}
</script>

<script setup>
import { Pagination, A11y, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

const props = defineProps({
  slides: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Object,
  },
})

const nextButton = ref(null)
const prevButton = ref(null)
</script>

<style lang="scss">
@import './style.scss';
</style>
